(() => {
  if (window.wlyCart) return;
  const wlyMobile = window.matchMedia('(max-width: 749px)');
  const wlyReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const wlyState = {
    lastFocus: null,
    queue: Promise.resolve(),
    timers: new Map(),
    refreshTimer: null,
    drag: null,
    upsellDrag: null,
    giftBusy: false,
    giftLastAdd: 0,
  };
  const wlyQ = (wlySelector, wlyScope = document) => wlyScope.querySelector(wlySelector);
  const wlyQA = (wlySelector, wlyScope = document) => Array.from(wlyScope.querySelectorAll(wlySelector));
  const wlyRoot = () => wlyQ('[data-wly-cart]');
  const wlyRootUrl = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const wlyConfig = () => {
    try {
      return JSON.parse(wlyQ('[data-wly-cart-config]')?.textContent || '{}');
    } catch (wlyErr) {
      return {};
    }
  };
  const wlySectionId = () => wlyConfig().section || 'wly-cart-drawer';
  const wlyPage = () => wlyQ('[data-wly-cart-page]');
  const wlyPageConfig = () => {
    try {
      return JSON.parse(wlyQ('[data-wly-cart-page-config]')?.textContent || '{}');
    } catch (wlyErr) {
      return {};
    }
  };
  const wlySectionIds = () => {
    const wlyIds = [];
    if (wlyRoot()) wlyIds.push(wlySectionId());
    if (wlyPage() && wlyPageConfig().section) wlyIds.push(wlyPageConfig().section);
    return wlyIds.length ? wlyIds.join(',') : wlySectionId();
  };
  const wlySpeed = () => {
    const wlyEl = wlyRoot();
    const wlyValue = wlyEl ? parseInt(getComputedStyle(wlyEl).getPropertyValue('--wly-cart-speed'), 10) : 320;
    return wlyReduce.matches ? 0 : wlyValue || 320;
  };
  const wlyIsOpen = () => !!wlyRoot()?.classList.contains('is-open');
  const wlyLock = (wlyOn) => document.documentElement.classList.toggle('wly-scroll-lock', wlyOn);
  const wlyFocusable = (wlyScope) => wlyQA('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', wlyScope).filter((wlyEl) => wlyEl.getClientRects().length > 0);
  const wlySetExpanded = (wlyOpen) => wlyQA('[data-wly-cart-open]').forEach((wlyBtn) => wlyBtn.setAttribute('aria-expanded', wlyOpen ? 'true' : 'false'));

  const wlyOpen = () => {
    const wlyEl = wlyRoot();
    if (!wlyEl) {
      window.location.href = `${wlyRootUrl()}cart`;
      return;
    }
    if (wlyIsOpen()) return;
    const wlyHeaderDrawer = wlyQ('[data-wly-drawer].is-open');
    if (wlyHeaderDrawer) wlyQ('.wly-header__drawer-close', wlyHeaderDrawer)?.click();
    const wlySearch = wlyQ('[data-wly-search].is-open');
    if (wlySearch) wlyQ('.wly-header__search-close', wlySearch)?.click();
    wlyState.lastFocus = document.activeElement;
    wlyEl.removeAttribute('inert');
    wlyEl.style.removeProperty('--wly-cart-drag');
    requestAnimationFrame(() => wlyEl.classList.add('is-open'));
    wlyLock(true);
    document.documentElement.classList.add('wly-cart-is-open');
    wlySetExpanded(true);
    window.setTimeout(() => wlyQ('[data-wly-cart-panel]', wlyEl)?.focus({ preventScroll: true }), 60);
    document.dispatchEvent(new CustomEvent('wly:cart:open'));
  };

  const wlyClose = () => {
    const wlyEl = wlyRoot();
    if (!wlyEl || !wlyIsOpen()) return;
    wlyEl.classList.remove('is-open', 'is-dragging');
    wlyEl.style.removeProperty('--wly-cart-drag');
    wlyLock(false);
    document.documentElement.classList.remove('wly-cart-is-open');
    wlySetExpanded(false);
    window.setTimeout(() => {
      if (!wlyIsOpen()) wlyEl.setAttribute('inert', '');
    }, wlySpeed());
    if (wlyState.lastFocus && wlyState.lastFocus.isConnected) wlyState.lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('wly:cart:close'));
  };

  let wlyBarObserver = null;
  const wlyBarWatch = () => {
    const wlyEl = wlyPage();
    if (wlyBarObserver) wlyBarObserver.disconnect();
    if (!wlyEl || !('IntersectionObserver' in window)) return;
    const wlyBar = wlyQ('[data-wly-cart-page-bar]', wlyEl);
    const wlyTarget = wlyQ('[data-wly-cart-page-checkout]', wlyEl);
    if (!wlyBar || !wlyTarget) return;
    wlyBarObserver = new IntersectionObserver((wlyEntries) => {
      const wlyEntry = wlyEntries[0];
      wlyBar.classList.toggle('is-hidden', wlyEntry.isIntersecting || wlyEntry.boundingClientRect.top < 0);
    });
    wlyBarObserver.observe(wlyTarget);
  };

  const wlyRenderPage = (wlyHtml) => {
    const wlyEl = wlyPage();
    if (!wlyEl || !wlyHtml) return;
    const wlyDoc = new DOMParser().parseFromString(wlyHtml, 'text/html');
    const wlyFresh = wlyQ('[data-wly-cart-page-inner]', wlyDoc);
    const wlyCurrent = wlyQ('[data-wly-cart-page-inner]', wlyEl);
    if (!wlyFresh || !wlyCurrent) return;
    const wlyActive = document.activeElement;
    const wlyActiveKey = wlyActive && wlyCurrent.contains(wlyActive) ? wlyActive.closest('[data-wly-cart-key]')?.getAttribute('data-wly-cart-key') : null;
    const wlyActiveRole = wlyActive?.hasAttribute('data-wly-cart-input') ? 'input' : wlyActive?.hasAttribute('data-wly-cart-plan-select') ? 'plan-select' : wlyActive?.hasAttribute('data-wly-cart-plan') ? 'plan' : wlyActive?.getAttribute('data-wly-cart-step');
    const wlyImported = document.importNode(wlyFresh, true);
    wlyCurrent.replaceWith(wlyImported);
    wlyBarWatch();
    if (wlyActiveRole) {
      const wlyLines = wlyQA('[data-wly-cart-key]', wlyImported);
      const wlyLine = wlyLines.find((wlyItem) => wlyItem.getAttribute('data-wly-cart-key') === wlyActiveKey);
      let wlyTarget = null;
      if (wlyLine) {
        if (wlyActiveRole === 'input') wlyTarget = wlyQ('[data-wly-cart-input]', wlyLine);
        else if (wlyActiveRole === 'plan-select') wlyTarget = wlyQ('[data-wly-cart-plan-select]', wlyLine);
        else if (wlyActiveRole === 'plan') wlyTarget = wlyQ('[data-wly-cart-plan]', wlyLine);
        else wlyTarget = wlyQ(`[data-wly-cart-step="${wlyActiveRole}"]`, wlyLine);
      }
      if (wlyTarget && !wlyTarget.disabled) wlyTarget.focus({ preventScroll: true });
    }
  };

  const wlyPageRendered = (wlySections) => !wlyPage() || !!(wlySections && wlyPageConfig().section && wlySections[wlyPageConfig().section]);

  const wlyRenderAll = (wlySections) => {
    if (!wlySections) return;
    try {
      if (wlySections[wlySectionId()]) wlyRender(wlySections[wlySectionId()]);
      const wlyPageId = wlyPageConfig().section;
      if (wlyPageId && wlySections[wlyPageId]) wlyRenderPage(wlySections[wlyPageId]);
    } catch (wlyErr) {
      if (wlyPage()) window.location.reload();
    }
  };

  const wlyRender = (wlyHtml) => {
    const wlyEl = wlyRoot();
    if (!wlyEl || !wlyHtml) return;
    const wlyDoc = new DOMParser().parseFromString(wlyHtml, 'text/html');
    const wlyFresh = wlyQ('[data-wly-cart-inner]', wlyDoc);
    const wlyCurrent = wlyQ('[data-wly-cart-inner]', wlyEl);
    if (!wlyFresh || !wlyCurrent) return;
    const wlyBodyScroll = wlyQ('[data-wly-cart-body]', wlyCurrent)?.scrollTop || 0;
    const wlyUpsellScroll = wlyQ('[data-wly-upsell-list]', wlyCurrent)?.scrollLeft || 0;
    const wlyActive = document.activeElement;
    const wlyActiveKey = wlyActive && wlyCurrent.contains(wlyActive) ? wlyActive.closest('[data-wly-cart-key]')?.getAttribute('data-wly-cart-key') : null;
    const wlyActiveRole = wlyActive?.hasAttribute('data-wly-cart-input') ? 'input' : wlyActive?.getAttribute('data-wly-cart-step');
    const wlyImported = document.importNode(wlyFresh, true);
    wlyCurrent.replaceWith(wlyImported);
    const wlyBody = wlyQ('[data-wly-cart-body]', wlyImported);
    if (wlyBody) wlyBody.scrollTop = wlyBodyScroll;
    const wlyUpsell = wlyQ('[data-wly-upsell-list]', wlyImported);
    if (wlyUpsell) wlyUpsell.scrollLeft = wlyUpsellScroll;
    if (wlyActiveKey) {
      const wlyLine = wlyQ(`[data-wly-cart-key="${CSS.escape(wlyActiveKey)}"]`, wlyImported);
      const wlyTarget = wlyLine && (wlyActiveRole === 'input' ? wlyQ('[data-wly-cart-input]', wlyLine) : wlyQ(`[data-wly-cart-step="${wlyActiveRole}"]`, wlyLine));
      if (wlyTarget && !wlyTarget.disabled) wlyTarget.focus({ preventScroll: true });
      else wlyQ('[data-wly-cart-panel]', wlyEl)?.focus({ preventScroll: true });
    }
  };

  const wlySyncOthers = (wlyCart) => {
    if (!wlyCart || typeof wlyCart.item_count !== 'number') return;
    const wlyTheme = window.theme && window.theme.Cart;
    if (wlyTheme) {
      try {
        if (typeof wlyTheme.setCurrentData === 'function') wlyTheme.setCurrentData(wlyCart);
        if (typeof wlyTheme.updateCounter === 'function') wlyTheme.updateCounter();
        if (wlyQ('.js-page-cart-ajax') && typeof wlyTheme.updateCartPageContent === 'function') wlyTheme.updateCartPageContent();
      } catch (wlyErr) {}
    }
    document.dispatchEvent(new CustomEvent('wly:cart:updated', { detail: { cart: wlyCart } }));
  };

  const wlyFetchCart = () => fetch(`${wlyRootUrl()}cart.js`, { headers: { Accept: 'application/json' }, wlyOwn: true }).then((wlyResponse) => wlyResponse.json());

  const wlyFetchSection = () => fetch(`${wlyRootUrl()}?sections=${encodeURIComponent(wlySectionIds())}`, { headers: { Accept: 'application/json' }, wlyOwn: true })
    .then((wlyResponse) => wlyResponse.json());

  const wlyRefresh = (wlyOptions = {}) => (window.clearTimeout(wlyState.refreshTimer), Promise.all([wlyFetchSection(), wlyFetchCart()]))
    .then(([wlySections, wlyCart]) => {
      wlyRenderAll(wlySections);
      wlySyncOthers(wlyCart);
      if (wlyOptions.open) wlyOpen();
      return wlyGiftCheck(wlyCart).then(() => wlyCart);
    })
    .catch(() => {
      if (wlyOptions.open) wlyOpen();
    });

  const wlyRefreshSoon = () => {
    window.clearTimeout(wlyState.refreshTimer);
    wlyState.refreshTimer = window.setTimeout(() => wlyRefresh(), 250);
  };

  const wlyPost = (wlyPath, wlyBody) => fetch(`${wlyRootUrl()}${wlyPath}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(Object.assign({}, wlyBody, { sections: wlySectionIds(), sections_url: window.location.pathname })),
    wlyOwn: true,
  }).then((wlyResponse) => wlyResponse.json().then((wlyData) => {
    if (!wlyResponse.ok) {
      const wlyError = new Error(wlyData.description || wlyData.message || wlyConfig().errorText || wlyPageConfig().errorText || 'Error');
      wlyError.data = wlyData;
      throw wlyError;
    }
    return wlyData;
  }));

  const wlyEnqueue = (wlyTask) => {
    wlyState.queue = wlyState.queue.then(wlyTask, wlyTask);
    return wlyState.queue;
  };

  const wlyChangeLine = (wlyKey, wlyQuantity, wlyPlan) => wlyEnqueue(() => {
    wlyQA(`[data-wly-cart-key="${CSS.escape(wlyKey)}"]`).forEach((wlyLine) => wlyLine.setAttribute('aria-busy', 'true'));
    const wlyBody = { id: wlyKey, quantity: wlyQuantity };
    if (wlyPlan !== undefined) wlyBody.selling_plan = wlyPlan ? Number(wlyPlan) : null;
    return wlyPost('cart/change.js', wlyBody)
      .then((wlyCart) => {
        if (wlyCart.sections) wlyRenderAll(wlyCart.sections);
        if (!wlyPageRendered(wlyCart.sections)) {
          window.location.reload();
          return null;
        }
        wlySyncOthers(wlyCart);
        if (wlyQuantity === 0) document.dispatchEvent(new CustomEvent('theme:cart::removed', { detail: { data: { key: wlyKey } } }));
        return wlyGiftCheck(wlyCart);
      })
      .catch((wlyErr) => {
        wlyQA(`[data-wly-cart-key="${CSS.escape(wlyKey)}"]`).forEach((wlyFresh) => {
          wlyFresh.removeAttribute('aria-busy');
          const wlyInput = wlyQ('[data-wly-cart-input]', wlyFresh);
          if (wlyInput) wlyInput.value = wlyFresh.getAttribute('data-wly-cart-qty');
          const wlyMessage = wlyQ('[data-wly-cart-error]', wlyFresh);
          if (wlyMessage) {
            wlyMessage.textContent = wlyErr.message;
            wlyMessage.hidden = false;
          }
        });
      });
  });

  const wlyAdd = (wlyItems, wlyOptions = {}) => wlyEnqueue(() => wlyPost('cart/add.js', { items: wlyItems })
    .then((wlyData) => {
      if (wlyData.sections) wlyRenderAll(wlyData.sections);
      if (!wlyPageRendered(wlyData.sections)) {
        window.location.reload();
        return wlyData;
      }
      document.dispatchEvent(new CustomEvent('theme:cart::added', { detail: { data: wlyData } }));
      return wlyFetchCart().then((wlyCart) => {
        wlySyncOthers(wlyCart);
        if (wlyOptions.open) wlyOpen();
        return wlyGiftCheck(wlyCart).then(() => wlyData);
      });
    }));

  const wlyScheduleLine = (wlyLine, wlyQuantity) => {
    const wlyKey = wlyLine.getAttribute('data-wly-cart-key');
    const wlyMax = parseInt(wlyLine.getAttribute('data-wly-cart-max') || '0', 10);
    let wlyQty = Math.max(0, Math.floor(Number(wlyQuantity) || 0));
    if (wlyMax > 0) wlyQty = Math.min(wlyQty, wlyMax);
    const wlyInput = wlyQ('[data-wly-cart-input]', wlyLine);
    if (wlyInput) wlyInput.value = wlyQty;
    const wlyError = wlyQ('[data-wly-cart-error]', wlyLine);
    if (wlyError) wlyError.hidden = true;
    window.clearTimeout(wlyState.timers.get(wlyKey));
    wlyState.timers.set(wlyKey, window.setTimeout(() => {
      wlyState.timers.delete(wlyKey);
      if (String(wlyQty) !== wlyLine.getAttribute('data-wly-cart-qty')) wlyChangeLine(wlyKey, wlyQty);
    }, wlyQty === 0 ? 0 : 400));
  };

  const wlyGiftCheck = (wlyCart) => {
    if (!wlyConfig().giftEnabled || wlyState.giftBusy || !wlyCart || !wlyCart.items) return Promise.resolve();
    const wlyGift = wlyQ('[data-wly-gift]');
    const wlyVariant = wlyGift ? parseInt(wlyGift.getAttribute('data-variant-id'), 10) : 0;
    const wlyThreshold = wlyGift ? parseInt(wlyGift.getAttribute('data-threshold'), 10) : 0;
    const wlyAvailable = wlyGift && wlyGift.getAttribute('data-available') === '1';
    if (!wlyVariant || !wlyThreshold) return Promise.resolve();
    const wlyIsGift = (wlyLine) => wlyLine.variant_id === wlyVariant && wlyLine.properties && String(wlyLine.properties._free_gift) === 'true';
    const wlyGiftLines = wlyCart.items.filter(wlyIsGift);
    const wlyGiftValue = wlyGiftLines.reduce((wlySum, wlyLine) => wlySum + wlyLine.final_line_price, 0);
    const wlyQualifying = Math.max(0, wlyCart.total_price - wlyGiftValue);
    const wlySeenKey = 'wly_gift_seen';
    const wlySuppressKey = 'wly_gift_suppressed_at';
    let wlySuppressed = null;
    let wlySeen = false;
    try {
      wlySuppressed = sessionStorage.getItem(wlySuppressKey);
      wlySeen = sessionStorage.getItem(wlySeenKey) === '1';
      if (wlyQualifying >= wlyThreshold && !wlyGiftLines.length && wlySeen && wlySuppressed === null) {
        wlySuppressed = String(wlyQualifying);
        sessionStorage.setItem(wlySuppressKey, wlySuppressed);
      }
      if (wlySuppressed !== null && parseInt(wlySuppressed, 10) !== wlyQualifying) {
        sessionStorage.removeItem(wlySuppressKey);
        wlySuppressed = null;
      }
      sessionStorage.setItem(wlySeenKey, wlyGiftLines.length ? '1' : '0');
    } catch (wlyErr) {}
    const wlyRun = (wlyTask) => {
      wlyState.giftBusy = true;
      return wlyTask().then(() => {
        wlyState.giftBusy = false;
        return wlyRefresh();
      }, () => {
        wlyState.giftBusy = false;
      });
    };
    const wlyRemoveAll = (wlyLines) => wlyLines.reduce((wlyChain, wlyLine) => wlyChain.then(() => wlyPost('cart/change.js', { id: wlyLine.key, quantity: 0 })), Promise.resolve());
    if (wlyQualifying >= wlyThreshold) {
      if (wlyGiftLines.length > 1) return wlyRun(() => wlyRemoveAll(wlyGiftLines.slice(1)));
      if (wlyGiftLines.length === 1 && wlyGiftLines[0].quantity > 1) return wlyRun(() => wlyPost('cart/change.js', { id: wlyGiftLines[0].key, quantity: 1 }));
      if (!wlyGiftLines.length && wlySuppressed === null && wlyAvailable && Date.now() - wlyState.giftLastAdd > 3000) {
        wlyState.giftLastAdd = Date.now();
        return wlyRun(() => wlyPost('cart/add.js', { items: [{ id: wlyVariant, quantity: 1, properties: { _free_gift: 'true' } }] }).then(() => {
          try {
            sessionStorage.setItem(wlySeenKey, '1');
          } catch (wlyErr) {}
        }));
      }
    } else if (wlyGiftLines.length) {
      return wlyRun(() => wlyRemoveAll(wlyGiftLines).then(() => {
        try {
          sessionStorage.removeItem(wlySuppressKey);
          sessionStorage.setItem(wlySeenKey, '0');
        } catch (wlyErr) {}
      }));
    }
    return Promise.resolve();
  };

  const wlyTrap = (wlyEvent) => {
    const wlyPanel = wlyQ('[data-wly-cart-panel]', wlyRoot());
    const wlyItems = wlyPanel ? wlyFocusable(wlyPanel) : [];
    if (!wlyItems.length) return;
    const wlyFirst = wlyItems[0];
    const wlyLast = wlyItems[wlyItems.length - 1];
    if (wlyEvent.shiftKey && document.activeElement === wlyFirst) {
      wlyEvent.preventDefault();
      wlyLast.focus();
    } else if (!wlyEvent.shiftKey && document.activeElement === wlyLast) {
      wlyEvent.preventDefault();
      wlyFirst.focus();
    }
  };

  document.addEventListener('click', (wlyEvent) => {
    const wlyTarget = wlyEvent.target;
    const wlyOpener = wlyTarget.closest('[data-wly-cart-open]');
    if (wlyOpener) {
      if (wlyRoot() && !wlyQ('[data-wly-cart-page]')) {
        wlyEvent.preventDefault();
        wlyOpen();
      }
      return;
    }
    if (!wlyTarget.closest('[data-wly-cart], [data-wly-cart-page]')) return;
    const wlyPlanBtn = wlyTarget.closest('[data-wly-cart-plan]');
    if (wlyPlanBtn) {
      wlyEvent.preventDefault();
      const wlyLine = wlyPlanBtn.closest('[data-wly-cart-key]');
      if (wlyLine) wlyChangeLine(wlyLine.getAttribute('data-wly-cart-key'), parseInt(wlyLine.getAttribute('data-wly-cart-qty'), 10) || 1, wlyPlanBtn.getAttribute('data-wly-cart-plan') || '');
      return;
    }
    if (wlyTarget.closest('[data-wly-cart-close]')) {
      wlyEvent.preventDefault();
      wlyClose();
      return;
    }
    const wlyStep = wlyTarget.closest('[data-wly-cart-step]');
    if (wlyStep) {
      wlyEvent.preventDefault();
      const wlyLine = wlyStep.closest('[data-wly-cart-key]');
      const wlyInput = wlyQ('[data-wly-cart-input]', wlyLine);
      const wlyCurrent = parseInt(wlyInput ? wlyInput.value : wlyLine.getAttribute('data-wly-cart-qty'), 10) || 0;
      wlyScheduleLine(wlyLine, wlyCurrent + parseInt(wlyStep.getAttribute('data-wly-cart-step'), 10));
      return;
    }
    const wlyRemove = wlyTarget.closest('[data-wly-cart-remove]');
    if (wlyRemove) {
      wlyEvent.preventDefault();
      wlyScheduleLine(wlyRemove.closest('[data-wly-cart-key]'), 0);
      return;
    }
    const wlyArrow = wlyTarget.closest('[data-wly-upsell-dir]');
    if (wlyArrow) {
      const wlyList = wlyQ('[data-wly-upsell-list]', wlyArrow.closest('[data-wly-upsell]'));
      const wlyItem = wlyList && wlyQ('[data-wly-upsell-item]', wlyList);
      if (wlyList) wlyList.scrollBy({ left: Number(wlyArrow.getAttribute('data-wly-upsell-dir')) * ((wlyItem ? wlyItem.getBoundingClientRect().width : wlyList.clientWidth) + 10), behavior: wlyReduce.matches ? 'auto' : 'smooth' });
      return;
    }
    const wlyUpsellAdd = wlyTarget.closest('[data-wly-upsell-add]');
    if (wlyUpsellAdd) {
      wlyEvent.preventDefault();
      const wlyItem = wlyUpsellAdd.closest('[data-wly-upsell-item]');
      const wlySelect = wlyQ('[data-wly-upsell-select]', wlyItem);
      const wlyId = Number(wlySelect ? wlySelect.value : wlyUpsellAdd.getAttribute('data-variant-id'));
      if (!wlyId) return;
      wlyUpsellAdd.disabled = true;
      wlyAdd([{ id: wlyId, quantity: 1 }]).catch(() => {
        wlyUpsellAdd.disabled = false;
      });
    }
  });

  document.addEventListener('change', (wlyEvent) => {
    const wlyPlanSelect = wlyEvent.target.closest('[data-wly-cart-plan-select]');
    if (wlyPlanSelect) {
      const wlyLine = wlyPlanSelect.closest('[data-wly-cart-key]');
      if (wlyLine) wlyChangeLine(wlyLine.getAttribute('data-wly-cart-key'), parseInt(wlyLine.getAttribute('data-wly-cart-qty'), 10) || 1, wlyPlanSelect.value);
      return;
    }
    const wlyInput = wlyEvent.target.closest('[data-wly-cart-input]');
    if (wlyInput) {
      wlyScheduleLine(wlyInput.closest('[data-wly-cart-key]'), wlyInput.value);
      return;
    }
    const wlySelect = wlyEvent.target.closest('[data-wly-upsell-select]');
    if (wlySelect) {
      const wlyOption = wlySelect.options[wlySelect.selectedIndex];
      const wlyPrice = wlyQ('[data-wly-upsell-price]', wlySelect.closest('[data-wly-upsell-item]'));
      if (wlyPrice && wlyOption) wlyPrice.textContent = wlyOption.getAttribute('data-price');
      const wlyImg = wlyQ('[data-wly-upsell-img]', wlySelect.closest('[data-wly-upsell-item]'));
      if (wlyImg && wlyOption && wlyOption.getAttribute('data-img')) {
        wlyImg.setAttribute('srcset', wlyOption.getAttribute('data-srcset') || '');
        wlyImg.setAttribute('src', wlyOption.getAttribute('data-img'));
      }
    }
  });

  document.addEventListener('keydown', (wlyEvent) => {
    if (wlyEvent.key === 'Enter' && wlyEvent.target.matches && wlyEvent.target.matches('[data-wly-cart-page] [data-wly-cart-input]')) {
      wlyEvent.preventDefault();
      wlyScheduleLine(wlyEvent.target.closest('[data-wly-cart-key]'), wlyEvent.target.value);
      return;
    }
    if (!wlyIsOpen()) return;
    if (wlyEvent.key === 'Escape') {
      wlyClose();
      return;
    }
    if (wlyEvent.key === 'Tab') wlyTrap(wlyEvent);
    if (wlyEvent.key === 'Enter' && wlyEvent.target.matches('[data-wly-cart-input]')) {
      wlyEvent.preventDefault();
      wlyScheduleLine(wlyEvent.target.closest('[data-wly-cart-key]'), wlyEvent.target.value);
    }
  });

  document.addEventListener('pointerdown', (wlyEvent) => {
    const wlyEl = wlyRoot();
    if (!wlyEl || !wlyIsOpen()) return;
    const wlyHandle = wlyEvent.target.closest('[data-wly-cart-drag]');
    if (wlyHandle && wlyMobile.matches && !wlyEvent.target.closest('button, a, input, select')) {
      const wlyPanel = wlyQ('[data-wly-cart-panel]', wlyEl);
      wlyState.drag = { startY: wlyEvent.clientY, startTime: performance.now(), height: wlyPanel.getBoundingClientRect().height, dy: 0, id: wlyEvent.pointerId };
      wlyEl.classList.add('is-dragging');
      try {
        wlyHandle.setPointerCapture(wlyEvent.pointerId);
      } catch (wlyErr) {}
      return;
    }
    if (wlyEvent.pointerType !== 'mouse' || wlyEvent.button !== 0) return;
    const wlyList = wlyEvent.target.closest('[data-wly-upsell-list]');
    if (!wlyList || wlyEvent.target.closest('select, button')) return;
    wlyState.upsellDrag = { list: wlyList, x: wlyEvent.clientX, left: wlyList.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', (wlyEvent) => {
    if (wlyState.drag && wlyEvent.pointerId === wlyState.drag.id) {
      const wlyDy = Math.max(0, wlyEvent.clientY - wlyState.drag.startY);
      wlyState.drag.dy = wlyDy;
      wlyRoot()?.style.setProperty('--wly-cart-drag', `${wlyDy}px`);
      return;
    }
    const wlyUp = wlyState.upsellDrag;
    if (!wlyUp) return;
    const wlyDx = wlyEvent.clientX - wlyUp.x;
    if (!wlyUp.moved && Math.abs(wlyDx) > 5) {
      wlyUp.moved = true;
      wlyUp.list.classList.add('is-dragging');
    }
    if (wlyUp.moved) {
      wlyEvent.preventDefault();
      wlyUp.list.scrollLeft = wlyUp.left - wlyDx;
    }
  });

  const wlyEndPointer = (wlyEvent) => {
    if (wlyState.drag && wlyEvent.pointerId === wlyState.drag.id) {
      const wlyDrag = wlyState.drag;
      wlyState.drag = null;
      const wlyEl = wlyRoot();
      if (!wlyEl) return;
      wlyEl.classList.remove('is-dragging');
      const wlyTime = Math.max(1, performance.now() - wlyDrag.startTime);
      const wlySpeedPx = wlyDrag.dy / wlyTime;
      if (wlyDrag.dy > wlyDrag.height * 0.25 || (wlyDrag.dy > 40 && wlySpeedPx > 0.6)) {
        wlyClose();
      } else {
        wlyEl.style.setProperty('--wly-cart-drag', '0px');
      }
      return;
    }
    const wlyUp = wlyState.upsellDrag;
    if (!wlyUp) return;
    wlyState.upsellDrag = null;
    if (!wlyUp.moved) return;
    const wlyItem = wlyQ('[data-wly-upsell-item]', wlyUp.list);
    const wlyStepWidth = wlyItem ? wlyItem.getBoundingClientRect().width + 10 : wlyUp.list.clientWidth;
    const wlyDx = (typeof wlyEvent.clientX === 'number' ? wlyEvent.clientX : wlyUp.x) - wlyUp.x;
    const wlyCount = wlyQA('[data-wly-upsell-item]', wlyUp.list).length;
    const wlyStart = Math.round(wlyUp.left / wlyStepWidth);
    const wlyTarget = Math.max(0, Math.min(wlyCount - 1, wlyStart + (wlyDx < -30 ? 1 : wlyDx > 30 ? -1 : 0)));
    wlyUp.list.scrollTo({ left: wlyTarget * wlyStepWidth, behavior: 'smooth' });
    window.setTimeout(() => wlyUp.list.classList.remove('is-dragging'), 450);
    const wlyBlock = (wlyClick) => {
      wlyClick.preventDefault();
      wlyClick.stopPropagation();
    };
    wlyUp.list.addEventListener('click', wlyBlock, { capture: true, once: true });
    window.setTimeout(() => wlyUp.list.removeEventListener('click', wlyBlock, true), 50);
  };
  document.addEventListener('pointerup', wlyEndPointer);
  document.addEventListener('pointercancel', wlyEndPointer);

  const wlyIsCartMutation = (wlyUrl) => typeof wlyUrl === 'string' && /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(wlyUrl);
  const wlyNativeFetch = window.fetch.bind(window);
  window.fetch = function (wlyInput, wlyInit) {
    const wlyUrl = typeof wlyInput === 'string' ? wlyInput : wlyInput && wlyInput.url;
    const wlyPromise = wlyNativeFetch(wlyInput, wlyInit);
    if (!(wlyInit && wlyInit.wlyOwn) && wlyIsCartMutation(wlyUrl)) {
      wlyPromise.then((wlyResponse) => {
        if (wlyResponse && wlyResponse.ok) wlyRefreshSoon();
      }).catch(() => {});
    }
    return wlyPromise;
  };
  const wlyXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (wlyMethod, wlyUrl) {
    this.wlyWatch = wlyIsCartMutation(String(wlyUrl));
    return wlyXhrOpen.apply(this, arguments);
  };
  const wlyXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.wlyWatch) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) wlyRefreshSoon();
      });
    }
    return wlyXhrSend.apply(this, arguments);
  };

  const wlyHookTheme = () => {
    const wlyTheme = window.theme;
    if (!wlyTheme) return false;
    if (wlyTheme.Cart && !wlyTheme.Cart.wlyHooked) {
      wlyTheme.Cart.showPopup = () => {
        window.clearTimeout(wlyState.refreshTimer);
        return wlyRefresh({ open: true });
      };
      wlyTheme.Cart.wlyHooked = true;
    }
    if (wlyTheme.Popups && typeof wlyTheme.Popups.callByName === 'function' && !wlyTheme.Popups.wlyHooked) {
      const wlyCall = wlyTheme.Popups.callByName.bind(wlyTheme.Popups);
      wlyTheme.Popups.callByName = function (wlyName) {
        if (wlyName === 'cart' && wlyRoot()) {
          wlyOpen();
          return true;
        }
        return wlyCall.apply(wlyTheme.Popups, arguments);
      };
      wlyTheme.Popups.wlyHooked = true;
    }
    return !!(wlyTheme.Cart && wlyTheme.Cart.wlyHooked && wlyTheme.Popups && wlyTheme.Popups.wlyHooked);
  };
  let wlyHookTries = 0;
  const wlyHookLoop = () => {
    if (wlyHookTheme() || ++wlyHookTries > 100) return;
    window.setTimeout(wlyHookLoop, 150);
  };
  wlyHookLoop();

  window.addEventListener('pageshow', (wlyEvent) => {
    if (wlyEvent.persisted) wlyRefresh();
  });
  document.addEventListener('shopify:section:load', (wlyEvent) => {
    if (wlyEvent.target && wlyEvent.target.querySelector && wlyEvent.target.querySelector('[data-wly-cart]')) wlyLock(false);
  });
  document.addEventListener('shopify:section:select', (wlyEvent) => {
    if (wlyEvent.target && wlyEvent.target.querySelector && wlyEvent.target.querySelector('[data-wly-cart]')) wlyOpen();
  });
  document.addEventListener('shopify:section:deselect', (wlyEvent) => {
    if (wlyEvent.target && wlyEvent.target.querySelector && wlyEvent.target.querySelector('[data-wly-cart]')) wlyClose();
  });

  if (wlyConfig().giftEnabled) {
    window.setTimeout(() => wlyFetchCart().then(wlyGiftCheck).catch(() => {}), 600);
  }

  wlyBarWatch();
  document.addEventListener('shopify:section:load', wlyBarWatch);

  window.wlyCart = {
    open: wlyOpen,
    close: wlyClose,
    refresh: wlyRefresh,
    add: wlyAdd,
    change: wlyChangeLine,
  };
  document.dispatchEvent(new CustomEvent('wly:cart:ready'));
})();
